"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var schema_1 = __importDefault(require("./schema"));
exports.schema = schema_1.default;
var normalizeNode_1 = __importDefault(require("./normalizeNode"));
exports.normalizeNode = normalizeNode_1.default;
//# sourceMappingURL=index.js.map